import React, { Component, Children } from 'react';
import { Map } from 'immutable';
import Icon from '../Icon';

export default class Wizard extends Component {
  constructor(props) {
    super(props);
    const currentStep = this.props.initialStep || 1;
    const summary = this.props.summary || new Map();
    this.state = {
      currentStep,
      summary,
      completed: false
    };
    this.getCurrentStep = this.getCurrentStep.bind(this);
    this.next = this.next.bind(this);
    this.back = this.back.bind(this);
    this.jump = this.jump.bind(this);
    this.updateSummary = this.updateSummary.bind(this);
  }

  componentWillUnmount() {
    if (!this.state.completed) {
      this.props.onPrematureExit(this.state.currentStep, this.state.summary);
    }
  }

  updateSummary(obj) {
    this.setState({
      summary: this.state.summary.merge(obj)
    });
  }

  next() {
    const nextStep = this.state.currentStep + 1;
    if (nextStep <= Children.count(this.props.children)) {
      this.setState({
        currentStep: nextStep
      });
    } else {
      console.log('state wizard', this.state);
      this.props.onComplete(this.state.summary);
      this.setState({
        completed: true
      });
    }
  }

  jump(page) {
    if (page < 1 || page > Children.count(this.props.children)) {
      console.warn(`trying to jump to invalid page: ${page}`);
    } else {
      this.setState({
        currentStep: page
      });
    }
  }

  back() {
    // eslint-disable-next-line react/prop-types
    const { noBackFromStep } = this.props;

    if (noBackFromStep && this.state.currentStep === noBackFromStep) {
      return;
    }
    this.setState({
      currentStep: this.state.currentStep - 1
    });
  }

  stepifyChildren() {
    this.steps = Children.map(this.props.children, child =>
      React.cloneElement(child, { next: this.next, updateSummary: this.updateSummary, summary: this.state.summary, jump: this.jump })
    );
  }

  getCurrentStep() {
    const index = this.state.currentStep - 1;
    if (!this.state.completed && this.steps && index < this.steps.length) {
      return this.steps[index];
    } else {
      return <div> This is the last step on the wizard, please handle this case in the container component </div>;
    }
  }

  render() {
    const { language, arrowClassName, containerClassName, noBackFromStep } = this.props;
    const { currentStep, completed } = this.state;
    this.stepifyChildren();
    const step = this.getCurrentStep();
    const button =
      currentStep <= 1 || currentStep === this.steps.length || completed || currentStep === noBackFromStep ? null : (
        <Icon name={`${language.startsWith('he') ? 'arrow-right' : 'arrow-left'}`} className={arrowClassName} onClick={this.back} />
      );
    return (
      <div className={containerClassName}>
        {button}
        {step}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.js